import React, { Component, Fragment } from "react";
import {
	Form,
	Select,
	Checkbox,
	Button,
	Table,
	Divider,
	Popconfirm,
	Spin,
	Input,
	InputNumber
} from "antd";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import isObject from "lodash/isObject";
import cloneDeep from "lodash/cloneDeep";
import cloneDeepWith from "lodash/cloneDeepWith";
import AddEditLinkSetProfileDialog from "./AddEditLinkSetProfileDialog";
import TagsInput from "components/TagsInput";

import { RouterState, routerStateToUrl } from "mobx-state-router";
import { createLocation } from "history";
import { history } from "utils/history";

const FormItem = Form.Item;
const Option = Select.Option;

const tailFormItemLayout = {
	wrapperCol: {
		xs: {
			span: 24,
			offset: 0
		},
		sm: {
			span: 21,
			offset: 3
		}
	}
};

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 3 }
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 21 }
	}
};

const columns = [
	{
		title: "ID",
		dataIndex: "linkSetId"
	},
	{
		title: "Name",
		dataIndex: "name"
	},
	{
		title: "Min Number of Links",
		dataIndex: "minLinks"
	},
	{
		title: "Max Number of Links",
		dataIndex: "maxLinks"
	},
	{
		title: "Percentage of Posts Having Links",
		dataIndex: "linkProb"
	},
	{
		title: "Action",
		dataIndex: "action",
		render: () => {
			return (
				<span>
					<a href="javascript:;">Edit</a>
					<Divider type="vertical" />
					<a href="javascript:;">Delete</a>
				</span>
			);
		}
	}
];

const data = [
	{
		key: "1",
		name: "Link Set 1",
		age: 32,
		address: "10%",
		action: "Edit"
	},
	{
		key: "2",
		name: "Link Set 2",
		age: 42,
		address: "20%",
		action: "Edit"
	},
	{
		key: "3",
		name: "Link Set 3",
		age: 32,
		address: "30%",
		action: "Edit"
	}
];

var getRawObjectFromFormObject = formObject => {
	function customizer(value) {
		if (isObject(value)) {
			if ("value" in value) {
				return value.value;
			}
		}
	}
	let rawJS = toJS(formObject);
	return cloneDeepWith(rawJS, customizer);
};

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class GeneralForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(
			{ scroll: { offsetBottom: 100 }, force: true },
			callback
		);
	};

	getColumnDefs = () => {
		let columnDefs = [
			{
				title: "ID",
				dataIndex: "linkSetId"
			},
			{
				title: "Name",
				dataIndex: "name"
			},
			{
				title: "Min Number of Links",
				dataIndex: "minLinks"
			},
			{
				title: "Max Number of Links",
				dataIndex: "maxLinks"
			},
			{
				title: "Percentage of Posts Having Links",
				dataIndex: "linkProb"
			}
		];
		if (this.props.ui.editing) {
			columnDefs.push({
				title: "Action",
				dataIndex: "action",
				render: (text, record) => {
					return (
						<span>
							<a
								href="javascript:;"
								onClick={() => {
									this.props.showEditLinkSetProfileDialog(record);
								}}
							>
								Edit
							</a>
							<Divider type="vertical" />
							<Popconfirm
								title="Sure to delete?"
								onConfirm={() => {
									this.props.deleteLinkSetProfile(record.linkSetId);
								}}
							>
								<a href="javascript:;">Delete</a>
							</Popconfirm>
						</span>
					);
				}
			});
		}
		return columnDefs;
	};

	compareToInputLinkSet = (rule, value, callback) => {
		const form = this.props.form;
		if (value) {
			const useLinkSet = this.props.form.getFieldValue("useLinkSet");
			if (useLinkSet == true) {
				for (let linkSetProfile of this.props.linkSetProfiles) {
					if (linkSetProfile.linkSetId == value) {
						callback("Output link set must be different to input link set");
						return;
					}
				}
			}
		}
		callback();
	};

	inputLinkSetsNotEmpty = (rule, value, callback) => {
		const useLinkSet = this.props.form.getFieldValue("useLinkSet");
		if (
			useLinkSet == true &&
			(!this.props.linkSetProfiles || this.props.linkSetProfiles.length == 0)
		) {
			callback("You must select input link sets");
			return;
		}
		callback();
	};

	openOutputLinkSet = () => {
		let routerStore = this.props.routerStore;
		let urlListId = this.props.form.getFieldValue("urlListId");
		if (urlListId) {
			const toState = new RouterState("links", { id: urlListId });
			const location = createLocation(routerStateToUrl(routerStore, toState));
			const href = history.createHref(location);
			window.open(href, "_blank");
		}
	};

	openContentBucket = () => {
		let routerStore = this.props.routerStore;
		let contentGroupId = this.props.form.getFieldValue("contentGroupId");
		if (contentGroupId) {
			const toState = new RouterState("contentGroup", { id: contentGroupId });
			const location = createLocation(routerStateToUrl(routerStore, toState));
			const href = history.createHref(location);
			window.open(href, "_blank");
		}
	};

	render() {
		let inputURLsSection = "";

		if (this.props.form.getFieldValue("useLinkSet")) {
			inputURLsSection = (
				<FormItem {...tailFormItemLayout} label="">
					<div>
						<Button
							type="primary"
							disabled={!this.props.ui.editing}
							onClick={this.props.showAddLinkSetProfileDialog}
						>
							Select Input URLs
						</Button>
					</div>
					<Table
						columns={this.getColumnDefs()}
						dataSource={this.props.linkSetProfiles}
						rowSelection={null}
						rowKey="linkSetId"
						size="small"
						pagination={{
							pageSize: 100
						}}
					/>
				</FormItem>
			);
		}

		return (
			<Fragment>
				<AddEditLinkSetProfileDialog />
				<FormItem label="Private Network" {...formItemLayout}>
					<span style={{ fontSize: 12 }}>
						<i>Select a private network.</i>
					</span>
					{this.props.form.getFieldDecorator("profileId", {
						rules: [
							{
								required: true,
								message: "You need to choose a private network"
							}
						]
					})(
						<Select
							showSearch
							style={{ width: "100%" }}
							placeholder="Please select a private network"
							disabled={!this.props.ui.editing}
							filterOption={true}
							optionFilterProp="name"
						>
							{this.props.privateNetworks.map(privateNetwork => {
								return (
									<Option key={privateNetwork.id} value={privateNetwork.id} name={privateNetwork.name}>
										{privateNetwork.name}
									</Option>
								);
							})}
						</Select>
					)}
				</FormItem>
				<FormItem label="Output Link Set" {...formItemLayout}>
					<span style={{ fontSize: 12 }}>
						<i>
							Select an output link set. This is where the backlinks created by
							this project are stored
						</i>
					</span>
					{this.props.form.getFieldDecorator("urlListId", {
						rules: [
							{
								required: true,
								message: "You need to choose where to store your backlinks"
							},
							{
								validator: this.compareToInputLinkSet
							}
						]
					})(
						<Select
							style={{ width: "100%" }}
							placeholder="Select an output link set"
							disabled={!this.props.ui.editing}
						>
							{this.props.urlLists.map(function(item) {
								return (
									<Option key={item.id} value={item.id}>
										{item.name}
									</Option>
								);
							})}
						</Select>
					)}
				</FormItem>
				<FormItem {...tailFormItemLayout}>
					<Button type="primary" onClick={this.openOutputLinkSet}>
						View
					</Button>
				</FormItem>
				<FormItem label="Content" {...formItemLayout}>
					<span style={{ fontSize: 12 }}>
						<i>
							Please select a content bucket. This project will get content from
							the chosen content bucket
						</i>
					</span>
					{this.props.form.getFieldDecorator("contentGroupId", {
						rules: [
							{
								required: true,
								message: "You need to choose where to get articles from"
							}
						]
					})(
						<Select
							style={{ width: "100%" }}
							placeholder="Select a content bucket"
							disabled={!this.props.ui.editing}
							showSearch
							filterOption={(input, option) =>
								option.props.children
								.toLowerCase()
								.indexOf(input.toLowerCase()) >= 0
							}								
						>
							{this.props.contentGroups.map(function(item) {
								return (
									<Option key={item.id} value={item.id}>
										{item.name}
									</Option>
								);
							})}
						</Select>
					)}
				</FormItem>
				<FormItem {...tailFormItemLayout}>
					<Button type="primary" onClick={this.openContentBucket}>View</Button>
				</FormItem>
				<FormItem label="URLs" {...formItemLayout}>
					<div>
						<span style={{ fontSize: 12 }}>
							<i>
								<b>Tick Insert URLs</b> if you want to insert URLs to your posts
							</i>
						</span>
					</div>
					{this.props.form.getFieldDecorator("useLinkSet", {
						valuePropName: "checked",
						rules: [
							{
								validator: this.inputLinkSetsNotEmpty
							}
						]
					})(
						<Checkbox disabled={!this.props.ui.editing}>
							Insert URLs to your posts
						</Checkbox>
					)}
				</FormItem>
				{inputURLsSection}
				<FormItem label="Link Position" {...formItemLayout}>
					{this.props.form.getFieldDecorator("linkPlacement",
					{
						rules: [
							{
								required: true,
								message:
									"Place select link position"
							}
						]
					})
					(
						<Select
							style={{ width: 200 }}
							placeholder="Select link position"
							disabled={!this.props.ui.editing}
						>
							<Option
								key="ReplaceKeyword"
								value="ReplaceKeyword"
							>
								Replace Keywords
							</Option>
							<Option key="Top" value="Top">
								Top
							</Option>
							<Option key="Bottom" value="Bottom">
								Bottom
							</Option>
							<Option
								key="RandomSentence"
								value="RandomSentence"
							>
								Between Sentences
							</Option>
							<Option
								key="RandomParagraph"
								value="RandomParagraph"
							>
								Between Paragraphs
							</Option>
							<Option
								key="ReplaceLinkTag"
								value="ReplaceLinkTag"
							>
								Replace Link Tags
							</Option>
							<Option
								key="InBlurbOnly"
								value="InBlurbOnly"
							>
								In Blurb Only
							</Option>
						</Select>
					)}
				</FormItem>				
				<FormItem label="Min Links" {...formItemLayout}>
					{this.props.form.getFieldDecorator("minLinks", {
							rules: [								
								{
									type: "integer",
								}
							]
						})(<InputNumber min={0} type="text" disabled={!this.props.ui.editing}/>)}
				</FormItem>
				<FormItem label="Max Links" {...formItemLayout}>
					{this.props.form.getFieldDecorator("maxLinks", {
							rules: [								
								{
									type: "integer",									
								}
							]
						})(<InputNumber min={0} type="text" disabled={!this.props.ui.editing}/>)}
				</FormItem>				
				<FormItem label="Output URL Anchors" {...formItemLayout}>
					{this.props.form.getFieldDecorator("outputAnchor")(
						<Input
							type="text"
							style={{ width: "100%" }}
							disabled={!this.props.ui.editing}
						/>
					)}
				</FormItem>
				<FormItem label="Tags" {...formItemLayout}>
					{this.props.form.getFieldDecorator("tags", {
						valuePropName: "tags",
						rules: [
							{
								required: true,
								message: "Please enter tags"
							}
						]
					})(<TagsInput disabled={!this.props.ui.editing} />)}
				</FormItem>
			</Fragment>
		);
	}
}

@inject("rootStore")
@observer
class GeneralTab extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	onFieldsChange = changedFields => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;
		privateProjectStore.formChanged(changedFields);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;

		const profiles = privateProjectStore.profiles;
		const stateForm = privateProjectStore.stateForm;

		let profileExists = profiles.some(profile => {
			return stateForm.profileId && profile.id == stateForm.profileId.value;
		});
	
		let profileId = profileExists
			? stateForm.profileId
			: { ...stateForm.profileId, value: undefined };

		return {
			profileId: Form.createFormField(profileId),
			urlListId: Form.createFormField(
				stateForm.urlListId.value == 0
					? { value: undefined }
					: stateForm.urlListId
			),
			contentGroupId: Form.createFormField(
				stateForm.contentGroupId.value == 0
					? { value: undefined }
					: stateForm.contentGroupId
			),
			useLinkSet: Form.createFormField(stateForm.useLinkSet),
			minLinks: Form.createFormField(stateForm.minLinks),
			maxLinks: Form.createFormField(stateForm.maxLinks),
			outputAnchor: Form.createFormField(stateForm.outputAnchor),
			insertImages: Form.createFormField(stateForm.insertImages),
			linkPlacement: Form.createFormField(stateForm.linkPlacement),
			tags: Form.createFormField(stateForm.tags)
		};
	};

	showAddLinkSetProfileDialog = () => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;

		privateProjectStore.showAddLinkSetProfileDialog();
	};

	showEditLinkSetProfileDialog = record => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;

		privateProjectStore.showEditLinkSetProfileDialog(record);
	};

	deleteLinkSetProfile = linkSetId => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;
		privateProjectStore.deleteLinkSetProfile(linkSetId);
	};

	render() {
		const {
			rootStore: { privateProjectStore, routerStore }
		} = this.props;
		const urlLists = privateProjectStore.urlLists;
		const contentGroups = privateProjectStore.contentGroups;
		const privateNetworks = privateProjectStore.profiles;

		const linkSetProfiles = toJS(privateProjectStore.stateForm.linkSetProfiles);
		const ui = privateProjectStore.ui;
		let spinning = ui.loadingPrivateSiteStatus == true;
		return (
			<Spin spinning={spinning}>
				<GeneralForm
					fields={this.mapPropsToFields()}
					urlLists={urlLists}
					contentGroups={contentGroups}
					linkSetProfiles={linkSetProfiles}
					onFieldsChange={this.onFieldsChange}
					privateNetworks={privateNetworks}
					ui={ui}
					routerStore={routerStore}
					showAddLinkSetProfileDialog={this.showAddLinkSetProfileDialog}
					showEditLinkSetProfileDialog={this.showEditLinkSetProfileDialog}
					deleteLinkSetProfile={this.deleteLinkSetProfile}
					wrappedComponentRef={internalForm => {
						this.internalForm = internalForm;
					}}
				/>
			</Spin>
		);
	}
}

export default GeneralTab;
